import { Children, type MouseEventHandler, type PropsWithChildren } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { ExpandCell } from "./ExpandCell";

type Props = PropsWithChildren<{
    isExpanded: boolean;
    onClick: MouseEventHandler<HTMLDivElement>;
}>;

export const WithExpandCell = ({ onClick, isExpanded, children }: Props) => {
    return Children.count(children) > 0 ? (
        <Flex
            gap="4px"
            minWidth={0}
        >
            <ExpandCell
                isExpanded={isExpanded}
                onClick={onClick}
            />
            {children}
        </Flex>
    ) : null;
};
